<template>
  <div class="marketplace-order-settings">
    <div v-if="platform !== 'glovo'" class="marketplace-order-settings__switches">
      <div class="marketplace-action-line"><label :for="platform + '-integration-active'">{{ $t('marketplace.integrationActive') }}</label><p-switch v-model="formData.active" type="success" :name="platform + '-integration-active'" :disabled="disabled" /></div>
      <div class="marketplace-action-line"><label :for="platform + '-auto-accept'">{{ fieldLabel('is_auto_accept') }}</label><p-switch v-model="formData.is_auto_accept" type="success" :name="platform + '-auto-accept'" :disabled="disabled" /></div>
      <div v-if="platform === 'bolt'" class="marketplace-action-line"><label for="bolt-own-delivery">{{ fieldLabel('has_own_delivery') }}</label><p-switch v-model="formData.has_own_delivery" type="success" name="bolt-own-delivery" :disabled="disabled" /></div>
    </div>
    <div v-if="platform === 'bolt'" class="form-group marketplace-order-settings__buffer">
      <label for="bolt-preparation-buffer">{{ fieldLabel('prep_time_buffer_in_minutes') }}</label>
      <input id="bolt-preparation-buffer" v-model="formData.prep_time_buffer_in_minutes" class="form-control" type="number" min="0" :disabled="disabled">
    </div>
    <div class="row marketplace-order-settings__polling"><integration-status-polling-field :form-data="formData" :disabled="disabled" /></div>
  </div>
</template>
<script>
import PSwitch from 'src/components/UIComponents/Switch.vue'
import IntegrationStatusPollingField from './IntegrationStatusPollingField.vue'
export default {
  components: { PSwitch, IntegrationStatusPollingField },
  props: {
    formData: { type: Object, required: true },
    platform: { type: String, required: true },
    disabled: { type: Boolean, default: false },
    fieldLabelFn: { type: Function, default: null }
  },
  methods: { fieldLabel (key) { return this.fieldLabelFn ? this.fieldLabelFn(key) : key } }
}
</script>
<style scoped>
.marketplace-order-settings__buffer { margin-top: 16px; max-width: 260px; }
.marketplace-order-settings__polling { margin-top: 16px; }
.marketplace-order-settings__polling >>> .col-md-6 { width: 100%; }
.marketplace-order-settings__polling >>> .form-group { margin-bottom: 0; }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Integrations/MarketplaceOrderSettings.vue